import { render, staticRenderFns } from "./form-design-list.vue?vue&type=template&id=6ff48866&"
import script from "./form-design-list.vue?vue&type=script&lang=js&"
export * from "./form-design-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports